class WebComponent {
  rootNode: Document | ShadowRoot = document;

  constructor(rootNode: Document | ShadowRoot) {
    this.rootNode = rootNode;
  }

  init(callback: VoidFunction) {
    callback();
  }
}

export { WebComponent };
